import { componentsEn } from './componentsEn';
import { componentsEs } from './componentsEs';
import { viewsEn } from './viewsEn';
import { viewsEs } from './viewsEs';
import { formsEn } from './formsEn';
import { formsEs } from './formsEs';
import { backEn } from './backEn';
import { backEs } from './backEs';
import { validationsEn } from './validationsEn';
import { validationsEs } from './validationsEs';
import { apiEn } from './apiEn';
import { apiEs } from './apiEs';

export const messages = {
  // ----------------------
  // Idioma inglés
  // ----------------------
  en: {
    // traducciones de componentes
    components: componentsEn,
    // traducciones de vistas
    views: viewsEn,
    // traducciones de formularios
    forms: formsEn,
    // traducciones de validaciones
    validations: validationsEn,
    // traducciones de datos que provienen de back
    back: backEn,
    // traducciones de partes de la api
    api: apiEn,
  },
  // ----------------------
  // Idioma español
  // ----------------------
  es: {
    // traducciones de componentes
    components: componentsEs,
    // traducciones de vistas
    views: viewsEs,
    // traducciones de formularios
    forms: formsEs,
    // traducciones de validaciones
    validations: validationsEs,
    // traducciones de datos que provienen de back
    back: backEs,
    // traducciones de partes de la api
    api: apiEs,
  }
};
